import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';
import Message from '../_generic/Message';

const ListOfAddressesAutocomplete = ({ addressList, selectAddress }) => {
  const theme = useContext(ThemeContext);
  const lookupAddressByAddressKey = (event, addressKey) => {
    // only select address if user pressed enter
    if (event && event.key && event.key !== 'Enter') return;

    event.preventDefault();
    selectAddress(addressKey);
  };

  if (!Array.isArray(addressList)) {
    return <Message message={addressList} />;
  }

  return (
    <>
      <ul className="address-list">
        {addressList.map(({ address, globalAddressKey }) => (
          <li className="address-list__item" key={globalAddressKey}>
            <a
              className="address-list__link"
              onClick={(event) =>
                lookupAddressByAddressKey(event, globalAddressKey)
              }
              onKeyDown={(event) =>
                lookupAddressByAddressKey(event, globalAddressKey)
              }
              role="link"
              tabIndex={0}
            >
              {address}
            </a>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .address-list {
          margin: -15px 0 1.6rem;
          border-radius: 0 0 4px 4px;
          border-color: #b3b3b3;
          border-style: solid;
          border-width: 0 1px 4px;
          overflow: auto;
          max-height: 220px;
          list-style: none;
          padding: 0;
        }
        .address-list__item {
          padding: 0;
        }
        .address-list__link {
          display: block;
          padding: 0.6rem 1.2rem;
          background-color: #ffffff;
          color: #333;
          font-style: italic;
          cursor: pointer;
          transition: all 120ms ease-in-out;
        }
        .address-list__link:hover {
          background: ${theme.colors.primary};
          color: #fff;
          text-decoration: none;
        }
      `}</style>
    </>
  );
};

ListOfAddressesAutocomplete.propTypes = {
  addressList: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
    .isRequired,
  selectAddress: PropTypes.func.isRequired,
};

export default ListOfAddressesAutocomplete;
